import {
  SET_VISIBLE_LOADING,
  SET_LOADING_LOCAL,
  SET_LOADING_MAPA,
  LOADING_START,
  LOADING_END,
  LOADING_RESET
} from '../actions/actionTypes';

const initialState = {
  visible: false,
  loadingCount: 0,
  loadingLocal: false,
  loadingMapa: false
};

export const loadingReducer = (state = initialState, action) => {
  switch (action.type) {

    case LOADING_START: {
      const count = state.loadingCount + 1;
      return {
        ...state,
        loadingCount: count,
        visible: count > 0
      };
    }

    case LOADING_END: {
      const count = Math.max(0, state.loadingCount - 1);
      return {
        ...state,
        loadingCount: count,
        visible: count > 0
      };
    }

    case LOADING_RESET: {
      const count = 0;
      return {
        ...state,
        loadingCount: count,
        visible: count > 0
      };
    }

    case SET_VISIBLE_LOADING:
      return {
        ...state,
        visible: action.payload,
        loadingCount: action.payload ? 1 : 0
      };

    case SET_LOADING_LOCAL:
      return { ...state, loadingLocal: action.payload };

    case SET_LOADING_MAPA:
      return { ...state, loadingMapa: action.payload };

    default:
      return state;
  }
};
